'use client';

import { BodyDefault } from '@terra/ui-design-system';
import { HStack } from '@terra/ui-styled-system';
import {
  AiMagicIcon,
  FlashIcon,
  SecurityCheckIcon,
  Settings02Icon,
  type TerraIcon,
} from '@terra/ui-icons';
import {
  TERMINAL_APPROVAL_POLICY_OPTIONS,
  type TerminalApprovalPolicy,
} from '@terra/shared-dto-chat-types';
import { useTranslations } from 'next-intl';
import { useState } from 'react';
import { useTerminalApprovalStore } from '../../store/terminalApprovalStore';
import { ComposerPillMenu, type ComposerPillTone } from './ComposerPillMenu';
import { TerminalApprovalRulesDialog } from './TerminalApprovalRulesDialog';

const MANAGE_RULES_VALUE = 'manage-rules';

const POLICY_ICONS: Record<TerminalApprovalPolicy, TerraIcon> = {
  allowlist: SecurityCheckIcon,
  'auto-review': AiMagicIcon,
  'run-everything': FlashIcon,
};

const POLICY_TONES: Record<TerminalApprovalPolicy, ComposerPillTone> = {
  allowlist: 'gray',
  'auto-review': 'blue',
  'run-everything': 'red',
};

export function TerminalApprovalSelector() {
  const t = useTranslations('chat.copilot.terminalApproval');
  const policy = useTerminalApprovalStore((state) => state.policy);
  const setPolicy = useTerminalApprovalStore((state) => state.setPolicy);
  const ruleCount = useTerminalApprovalStore(
    (state) => state.rules.length + state.toolRules.length,
  );
  const [isRulesOpen, setIsRulesOpen] = useState(false);
  const options = TERMINAL_APPROVAL_POLICY_OPTIONS.map((value) => ({
    value,
    label: t(`${value}Label`),
    description: t(`${value}Description`),
    icon: POLICY_ICONS[value],
    tone: POLICY_TONES[value],
  }));
  const manageRulesItem = {
    value: MANAGE_RULES_VALUE,
    onClick: () => setIsRulesOpen(true),
    label: (
      <HStack gap={1.5} alignItems="center" color="fg.muted">
        <Settings02Icon size={14} />
        <BodyDefault color="fg.muted">
          {t('manageRules', { count: ruleCount })}
        </BodyDefault>
      </HStack>
    ),
  };

  return (
    <>
      <ComposerPillMenu
        ariaLabel={t('selectorLabel')}
        options={options}
        value={policy}
        onValueChange={setPolicy}
        extraItems={[manageRulesItem]}
        contentWidth="300px"
      />
      <TerminalApprovalRulesDialog
        isOpen={isRulesOpen}
        onClose={() => setIsRulesOpen(false)}
      />
    </>
  );
}
